import { reactive, ref } from "vue";
import { list } from "@/api/member/plateNumberApi";
import useMessage from "@/hooks/useMessage";
const usePlateNumber = () => {
  const { showErr } = useMessage();
  const loading = ref(false);
  const dataList = reactive({ list: [] });
  const total = ref(0);
  const columns = [
    {
      title: "序号",
      align: "center",
      width: "80px",
      customRender: ({ index }) => {
        return index + 1;
      },
    },
    {
      title: "车牌号",
      align: "center",
      dataIndex: "plateNumber",
      slots: { customRender: "plateNumber" },
    },
    {
      title: "用户昵称",
      align: "center",
      dataIndex: "nickName",
    },
    {
      title: "手机号码",
      align: "center",
      dataIndex: "phone",
    },
    {
      title: "绑定时间",
      align: "center",
      dataIndex: "createTime",
    },
    {
      title: "操作",
      align: "center",
      width: "240px",
      slots: { customRender: "operation" },
    },
  ];
  const loadData = async (page, pageSize) => {
    loading.value = true;
    try {
      let res = await list(
        params.plateNumber,
        params.nickName,
        params.phone,
        page,
        pageSize,
      );
      dataList.list = res.data;
      total.value = res.total;
      loading.value = false;
    } catch (e) {
      loading.value = false;
      await showErr(e);
    }
  };

  const params = reactive({
    plateNumber: "",
    nickName: "",
    phone: "",
  });
  return {
    loading,
    params,
    dataList,
    total,
    columns,
    loadData,
  };
};
export default usePlateNumber;
